import { useState } from "react";
import { Navigate, useNavigate, Link } from "react-router-dom";
import { ArrowRight, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/submitSilverCampaign";
import Atmosphere from "@/components/silver/layout/Atmosphere";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid min-h-screen place-items-center px-5">
      <Atmosphere />
      <form onSubmit={submit} className="glass-strong w-full max-w-md p-8 sm:p-10" data-testid="admin-login-form">
        <Link to="/"><img src="/brand/nichecom-wordmark-dark.png" alt="NicheCom" className="h-6 w-auto" /></Link>
        <p className="eyebrow mt-10">NicheCom Print · Team</p>
        <h1 className="mt-3 text-3xl font-extrabold tracking-[-0.04em]">Campaign briefs</h1>
        <p className="mt-2 text-[14px] text-white/55">Sign in to review submitted audiences and briefs.</p>
        <label className="mt-8 block">
          <span className="text-[12px] font-semibold text-white/75">Email</span>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="username" className="field mt-1.5 w-full px-4 py-3" data-testid="admin-email-input" />
        </label>
        <label className="mt-4 block">
          <span className="text-[12px] font-semibold text-white/75">Password</span>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" className="field mt-1.5 w-full px-4 py-3" data-testid="admin-password-input" />
        </label>
        {error && <p className="mt-4 text-[13px] text-[#FCA5A5]" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={busy} className="btn-primary mt-8 w-full" data-testid="admin-login-submit-btn">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <>Sign in <ArrowRight className="h-4 w-4" /></>}
        </button>
      </form>
    </div>
  );
}
